import * as angular from 'angular';
import { RegentsPlanningTableComponent } from './regents-planning-table.component';

export const RegentsPlanningTableModule = angular
  .module('regentsPlanningTableModule', [])
  .component('regentsPlanningTable', RegentsPlanningTableComponent).name;
